// import Http from '../API'

const ssh = {
  state: {
    status: false,
    connection: null,
    dev_id: '',
    term: null,
    fitAddon: null,
    timer_connect: 0
  },
  getters:{
    getStatus: (state) => {
      return state.status
    },
    getConnection: (state) => {
      return state.connection
    },
    getDeviceID: (state) => {
      return state.dev_id
    },
    getTerm: (state) => {
      return state.term
    },
    getFitAddon: (state) => {
      return state.fitAddon
    },
    getTimerConnect: (state) => {
      return state.timer_connect
    },
  },
  mutations: {
    setStatus (state, new_status) {
      state.status = new_status
    },
    setConnection (state, new_connection) {
      state.connection = new_connection
    },
    setDeviceID (state, new_dev_id) {
      state.dev_id = new_dev_id
    },
    setTerm (state, new_term) {
      state.term = new_term
    },
    setFitAddon (state, new_fit_addon) {
      state.fitAddon = new_fit_addon
    },
    setTimerConnect (state, new_time) {
      state.timer_connect = new_time
    },
    resetTimer (state) {
      state.timer_connect = 0
    },
    resetState (state) {
      state.status = false
      state.connection = null
      state.dev_id = ''
      state.term = null
      state.fitAddon = null
      state.timer_connect = 0
    }
  },
  actions: {
  }
}

export default ssh
